/**
 * Draw coating for wall front view
 *
 * Used to draw a polygone form on a wall which will be filled with a coating inside
 */

import { AreaState, AreaStateEditModeEnum , ActionState, ActionStateEnum, FrontViewState} from "..";
import { Command, HP_GLOBAL_RESOURCES } from "../../../../constants";
import { FrontViewManager } from "../../plan/FrontViewManager";
import { PlanManager } from "../../../../cocosPlan";
import { Area, ArrangementObject, CoatingArea, Commands, ComponentConstants, Entity, Events, eventsManager, Joinery, Listener, math, SavaneConstants, SavaneMath, Segment, TechnicalElement } from "@rhinov/savane-js";
import { getToken, getUrl } from "@rhinov/asset-manager-service";

declare var $: any;
declare var cc: any;



export class FrontViewCoating extends AreaState {

    _originalCursorPosition: math.vec3 | null = null;
    // Open tulip at the end
    _openTulip: boolean = true;
    _coating: any = null;
    _selectedSVG: SVGElement | null = null;
    _addCoatingListener: Listener | null = null;
    _startRectSelectionPosition: math.vec3 | null = null;
    _shiftPressed: boolean = false;

    constructor(coating: any, editMode: number, cursorPosition: math.vec3) {
        super(editMode ? coating : null, cursorPosition, editMode ? undefined : coating);
        // Store edition mode (create or edit)
        //this.editMode = editMode;
        // Record cursor position
        if (cursorPosition) {
            this._originalCursorPosition = math.vec3.clone(cursorPosition);
        }
        
        
        // If edit
        if (!editMode) {
            // Store the coating used to create the area
            this._coating = coating;
        }

        
        var SVGPath = HP_GLOBAL_RESOURCES.resourcesBasePath + "svg/square.svg";
        if (PlanManager.getInstance().selectedSVGBrush) {
            SVGPath = getUrl() + 'api/v1/svgs/' + PlanManager.getInstance().selectedSVGBrush + '/svg' + '?apikey=' + getToken();
        }
        var SVGContainer = document.createElement('div');
        var xhr = new XMLHttpRequest();
        xhr.open('GET', SVGPath, true);
        xhr.onreadystatechange = () => {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    var data = xhr.responseText;
                    SVGContainer.innerHTML = data;
                    var SVGElements = SVGContainer.querySelectorAll("svg");
                    SVGContainer.remove();
                    if (SVGElements.length > 0) {
                        this._selectedSVG = SVGElements[0] as SVGElement;
                    }
                }
            }
        };
        xhr.send();

        this._addCoatingListener = eventsManager.instance.addListener(Events.COATING_DRAG,
            (data: any) => {
                FrontViewManager.unselectDecoration(this._area!);
                if (this._originalCursorPosition) {
                    eventsManager.instance.dispatch(Events.CHANGE_STATE, new FrontViewCoating(data.userData.coating, Number(false), this._originalCursorPosition));
                }
            }
        );

        // Set current state enum
        this.state = ActionStateEnum.FrontViewCoating;
    }

    getAction(): number {
        return ActionStateEnum.FrontViewCoating;
    }

    // Go to next state after the front view coating state (i.e. go back to front view state)
    nextState(): ActionState | null {
        FrontViewManager.unselectDecoration(this._area!);
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.FrontView);
        return new FrontViewState();
    }

    isDecorationState(): boolean {
        return (true);
    }

    // Create a command to delete the current area (so it can be undone)
    deleteCommand(): Command {
        return new Commands.DeleteComponentCommand(this._area!, true);
    }

    // Create a command to create a new area (so it can be undone)
    addCommand(): Command {
        return new Commands.AddComponentCommand(this._area!, this._entity!, false, true);
    }

    // Transforms current cursor position (X, Z) into front view coordinates (X, Y)
    transformCursorPosition(cursorPosition: math.vec3): math.vec3 {
        var pos = math.vec3.clone(cursorPosition);
        pos[1] = pos[2];
        pos[2] = 0;
        return (pos);
    }

    // State initialisation
    init(area: Area, cursorPosition: math.vec3, entity?: Entity, doubleClick?: boolean, coating?: any) {
        $('#gameCanvas').focus();

        // Temporary variable to send modified cursor position (Z --> Y) to area state
        var pos: math.vec3 | null = null;
        if (coating) {
            this._coating = coating;
        }

        if (cursorPosition) {
            pos = this.transformCursorPosition(cursorPosition);
        }

        // Call area state initialisation (it will create an area but we wil overwrite it below)
        super.init(area, pos as any, PlanManager.getInstance().frontViewLayer.currentWall!);

        // If we are creating a new coating area
        if (this.editMode === AreaStateEditModeEnum.new_area) {
            // Let's try to load a diffuse media from the coating within the asset manager (it might be missing)
            var urlPreview = this._coating.url + this._coating._id + '/medias/maps/diffuse' + this._coating.choosenIndex + '.jpg';

            urlPreview = urlPreview.replace("assets", "coatings");

            // Create a coating area for the area (and not simply an normal area as we need a coating info in addition to the standard fields of area object)
            if (this._coating.colors !== undefined) {
                // New structure with realColor at the root of the AM coating
                this._area = new CoatingArea(this._coating._id, this._coating.manufacturer, this._coating.retailer, this._coating.hangType, [this._coating.colors], this._coating.randomization, this._coating.isHpFloorGenerator ? this._coating.hpFloorGeneratorSettings : undefined, urlPreview);
            }
            else {
                // Old structure with colors in configs
                this._area = new CoatingArea(this._coating._id, this._coating.manufacturer, this._coating.retailer, this._coating.hangType, this._coating.configs, this._coating.randomization, this._coating.isHpFloorGenerator ? this._coating.hpFloorGeneratorSettings : undefined, urlPreview);
            }
            // Store the entity owning the coating area
            this._area.entity = PlanManager.getInstance().frontViewLayer.currentWall;
            // Store the desired color index for the coating
            //this._area.colorIndex = this._coating.colorIndex !== undefined ? this._coating.colorIndex : this._coating.configs[0].index;
            // And if we have a cursorPosition pass to this method, store it as the first point of the area
            if (cursorPosition && pos) {
                this._area!.vertices = [pos];
            }
            else {
                this._area!.vertices = [];
            }
            // Store if direct side or not (side from begin to end or the other side)
            this._area!.isDirectSide = PlanManager.getInstance().frontViewLayer.isDirectSide;
        }
        else {
            FrontViewManager.selectDecoration(this._area! as Area);
            if (pos && SavaneMath.isInPoly(pos, this._area!.vertices)) {
                this._isEditing = true;
                this.editMode = AreaStateEditModeEnum.area_selected;
            }
        }
    }

    // Draw the current CoatingArea
    drawArea(drawArea: any) {
        // If we are editing, set the area as selected to display it with a different color
        var SVG = null;
        if (PlanManager.getInstance().frontViewDrawMode === 1) {
            if (PlanManager.getInstance().selectedSVGBrush) {
                SVG = getUrl() + 'api/v1/svgs/' + PlanManager.getInstance().selectedSVGBrush + '/svg' + '?apikey=' + getToken();
            } else {
                SVG = HP_GLOBAL_RESOURCES.resourcesBasePath + "svg/square.svg";
            }
        }

        FrontViewManager.drawArea(this._area!, drawArea, this.editMode, this._editedPointIndex ?? -1, this._editedLineIndex ?? -1, SVG);
    }

    // Delete the current CoatingArea
    deleteArea() {
        if (this._area!.id !== null) {
            FrontViewManager.deleteArea(this._area!.id);
        }
    }

    // Mouse button pressEd
    mouseClickDown(cursorPosition: math.vec3, doubleClick?: boolean, hoverEntities?: Entity[], mouseButton?: number): ActionState | null {
        if (mouseButton === 2) {
            return PlanManager.getInstance().mouseClickCancelled();
        }
        // Modify cursor position (Z --> Y)
        var pos = this.transformCursorPosition(cursorPosition);
        // Call the AreaState method and store result (where to go)
        var state = super.mouseClickDown(pos, doubleClick ?? false, hoverEntities ?? [], mouseButton ?? 0, true);
        switch (this.editMode) {
            case AreaStateEditModeEnum.area_selected:
            case AreaStateEditModeEnum.point_selected:
            case AreaStateEditModeEnum.line_selected:
                this._isEditing = true;
                break;
        }

        this._startRectSelectionPosition = pos;

        // Close any tulip here
        PlanManager.getInstance().updateItemsSelected(null, this._isEditing, false);

        // If edit mode is unknown then it means we have clicked outside of the current coating area
        if (this.editMode === AreaStateEditModeEnum.unknown) {
            // Current area isn't edited anymore, check all coating area
            var isDirectSide = PlanManager.getInstance().frontViewLayer.isDirectSide;
            var areaCoatings = PlanManager.getInstance().frontViewLayer.currentWall!.getComponents(ComponentConstants.ComponentType.CoatingArea) as CoatingArea[];

            // Parse them all
            for (var i = 0; i < areaCoatings.length; ++i) {
                // If one found with current direct side and the cursor position is in the polygon
                if (areaCoatings[i].isDirectSide === isDirectSide && SavaneMath.isInPoly(pos, areaCoatings[i].vertices)) {
                    // Unselect current coating area
                    FrontViewManager.unselectDecoration(this._area!);
                    // Create a new view coating state with the new edited coating
                    return new FrontViewCoating(areaCoatings[i], Number(true), cursorPosition);
                }
            }

            // No new coating area selected, go back to Front View
            return (this.nextState());
        }
        else {
            // Return result from Area State call
            return (state);
        }
    }

    // The mouse button is released
    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        if (this.editMode === AreaStateEditModeEnum.new_area && PlanManager.getInstance().frontViewDrawMode === 1 &&
            this._area!.vertices.length === 4) {
            this.deleteArea();
            this._generateCoatingAreaFromSVG();
            this._updateWebGlDynamicHull();
            super.cancelAllActions();
            return this.nextState();
        }
        // Transform mouse cursor coordinates (Z --> Y)
        var pos = this.transformCursorPosition(cursorPosition);
        if (this._coating && this._area!.vertices.length === 1) { // drag over area -> replace coating
            var isDirectSide = PlanManager.getInstance().frontViewLayer.isDirectSide;
            var areaCoatings = PlanManager.getInstance().frontViewLayer.currentWall!.getComponents(ComponentConstants.ComponentType.CoatingArea) as CoatingArea[];

            for (var i = (areaCoatings as any).length - 1; i >= 0; --i) {
                if (areaCoatings[i].isDirectSide === isDirectSide && SavaneMath.isInPoly(pos, areaCoatings[i].vertices)) {
                    var area = areaCoatings[i];
                    this.deleteArea();
                    if (area.id !== null) {
                        FrontViewManager.deleteArea(area.id);
                    }
                    this._area!.vertices = area.vertices.slice();
                    (this._area! as CoatingArea).isDirectSide = area.isDirectSide;
                    if ((area as any).floorGeneratorSettings) {
                        eventsManager.instance.dispatch(Events.SHOW_CONTEXTUAL_MENU_COATING_AREA, {
                            jointCallback: (area as any).floorGeneratorSettings?.cleat ? null : () => {
                                if (this._coating.isHpFloorGenerator) {
                                    eventsManager.instance.dispatch(Events.DISPLAY_ALERT, { message: 'Les matériaux FloorGenerator sont interdits sur les joints.' });
                                } else {
                                    (area as any).floorGeneratorSettings.jointCoating = {
                                        id: this._coating._id,
                                        colors: (this._coating.colors !== undefined ? [this._coating.colors] : this._coating.configs)
                                    }
                                    this.deleteArea();
                                    if (area.id !== null) {
                                        FrontViewManager.deleteArea(area.id);
                                    }
                                    PlanManager.getInstance().saveInCache();
                                    eventsManager.instance.dispatch(Events.FRONTVIEW_FLOOR_GENERATOR_CHANGED);
                                }
                                ($('#ContextualMenuCoatingArea') as any).css('display', 'none');
                            },
                            cleatCallback: (area as any).floorGeneratorSettings.cleat ? () => {
                                (this._area! as any).floorGeneratorSettings = (area as any).floorGeneratorSettings;
                                (this._area! as any).floorGeneratorSettings.tile.texturesCount = 1;
                                (this._area! as any).rotation = (area as any).rotation;
                                this.deleteArea();
                                if (area.id !== null) {
                                    FrontViewManager.deleteArea(area.id);
                                }
                                if (this._entity) {
                                    PlanManager.getInstance().executeCommand(new Commands.ReplaceComponentCommand(area, this._area!, this._entity));
                                }
                                eventsManager.instance.dispatch(Events.FRONTVIEW_FLOOR_GENERATOR_CHANGED);
                                ($('#ContextualMenuCoatingArea') as any).css('display', 'none');
                                PlanManager.getInstance().frontViewLayer.renderCurrentWall();
                            } : null,
                            replaceCallback: () => {
                                this.deleteArea();
                                if (area.id !== null) {
                                    FrontViewManager.deleteArea(area.id);
                                }
                                if (this._entity) {
                                    PlanManager.getInstance().executeCommand(new Commands.ReplaceComponentCommand(area, this._area!, this._entity));
                                }
                                ($('#ContextualMenuCoatingArea') as any).css('display', 'none');
                                PlanManager.getInstance().frontViewLayer.renderCurrentWall();
                            },
                        });
                        var newState = new FrontViewCoating(this._area, 0, cursorPosition);
                        newState.cancelAllActions();
                        return newState;
                    } else {
                        PlanManager.getInstance().executeCommand(new Commands.ReplaceComponentCommand(area, this._area!, this._entity!));
                        var newState = new FrontViewCoating(this._area!, 0, cursorPosition);
                        newState.cancelAllActions();
                        return newState;
                    }
                }
            }
        }
        // If we are drawing points, let's delete it (it will be created again below)
        if (this._isDrawingPoint) {
            this.deleteArea();
        }

        if (this.editMode === AreaStateEditModeEnum.area_selected && this._isEditing === true && this._openTulip === false) {
            this._updateWebGlDynamicHull();
        }

        // Call area state method with the cursor position and store the result
        var state = super.mouseClickUp(pos, elapsedTime, hoverEntities, mouseButton);

        if (state === null) {

            switch (this.editMode) {
                case AreaStateEditModeEnum.area_selected:
                case AreaStateEditModeEnum.point_selected:
                case AreaStateEditModeEnum.line_selected:
                    this.drawArea(this.editMode);
                    if (this._openTulip && this._entity) {
                        PlanManager.getInstance().updateItemsSelected([this._entity], true, true);
                    }
                    break;
                default:
                    if (this._isDrawingPoint === false && this._editedPointIndex === null) {
                        super.cancelAllActions();
                        return this.nextState();
                    }
                    break;
            }
        }

        // Go to the result of the area state call
        return state;
    }

    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        // Do we have to open the tulip at the end of the current operation ?
        if (!this._originalCursorPosition) {
            this._originalCursorPosition = math.vec3.clone(cursorPosition);
        }
        if (math.vec3.distance(this._originalCursorPosition, cursorPosition) > SavaneConstants.PositionTolerance) {
            this._openTulip = false;
        }

        // Change cursor pour to a vertical plane position (instead of horizontal)
        var pos = this.transformCursorPosition(cursorPosition);
        // Call AreaState method to know what to do and store result
        var toReturn = super.moveMouseCursor(pos);

        if (this.editMode === AreaStateEditModeEnum.new_area && PlanManager.getInstance().frontViewDrawMode === 1 &&
            this._startRectSelectionPosition) {
            // SVG view box
            if (this._area!.vertices.length > 0) {
                var vertices = [this._startRectSelectionPosition];
                if (this._shiftPressed) {
                    pos[1] = vertices[0][1] + ((vertices[0][0] - pos[0]) * this._getSVGAspectRatio());
                }
                vertices.push([pos[0], vertices[0][1], vertices[0][2]]);
                vertices.push([pos[0], pos[1], vertices[0][2]]);
                vertices.push([vertices[0][0], pos[1], vertices[0][2]]);
                this._area!.vertices = vertices;
            }
        }

        // Compute if the shape is valid
        this._isValid();

        // The current area
        this.drawArea(this.editMode);
        // Return result of the call above
        return (toReturn);
    }

    mouseClickCancelled(cursorPosition: math.vec3): ActionState | null {
        super.mouseClickCancelled(cursorPosition);
        PlanManager.getInstance().frontViewLayer.renderCurrentWall();
        return this.nextState();
    }

    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        if ((keyCode === cc.KEY.Delete || keyCode == cc.KEY.backspace)) {
            this.editMode = AreaStateEditModeEnum.unknown;
            this.drawArea(this.editMode);
        }
        var nextState = super.keyPressed(keyCode);
        // Page up and page down, flip the wall edited side
        if ((keyCode === 33) || (keyCode === 34)) {
            PlanManager.getInstance().frontViewLayer.toggleSide();
        }

        if (keyCode === cc.KEY.s) {
            PlanManager.getInstance().snapEnabled = !PlanManager.getInstance().snapEnabled;
            eventsManager.instance.dispatch(Events.SNAP_UPDATED);
        }

        if (keyCode === cc.KEY.a) {
            PlanManager.getInstance().magnetRotation = !PlanManager.getInstance().magnetRotation;
            eventsManager.instance.dispatch(Events.ANGLE_SNAP_UPDATED);
        }

        if (this._previousPosition) {
            var entity = this._entity as ArrangementObject | Joinery | TechnicalElement
            // fill top
            if (keyCode === cc.KEY.t) {
                nextState = this._makeRect(0, PlanManager.getInstance().frontViewLayer.computeWallLength(), Math.floor(this._previousPosition[1]), entity.height);
            }

            // fill bottom
            if (keyCode === cc.KEY.b) {
                nextState = this._makeRect(0, PlanManager.getInstance().frontViewLayer.computeWallLength(), PlanManager.getInstance().frontViewLayer.computeFloorHeight(), Math.floor(this._previousPosition[1]));
            }

            // fill wall
            if (keyCode === cc.KEY.g) {
                nextState = this._makeRect(0, PlanManager.getInstance().frontViewLayer.computeWallLength(), PlanManager.getInstance().frontViewLayer.computeFloorHeight(), entity.height);
            }

            // fill left
            if (keyCode === cc.KEY.f) {
                nextState = this._makeRect(0, Math.floor(this._previousPosition[0]), PlanManager.getInstance().frontViewLayer.computeFloorHeight(), entity.height);
            }

            // fill right
            if (keyCode === cc.KEY.h) {
                nextState = this._makeRect(Math.floor(this._previousPosition[0]), PlanManager.getInstance().frontViewLayer.computeWallLength(), PlanManager.getInstance().frontViewLayer.computeFloorHeight(), entity.height);
            }
        }

        if (keyCode === cc.KEY.left || keyCode === cc.KEY.right || keyCode === cc.KEY.up || keyCode === cc.KEY.down) {
            var delta = math.vec3.create();
            switch (keyCode) {
                case cc.KEY.left:
                    delta[0] = -10;
                    break;
                case cc.KEY.right:
                    delta[0] = 10;
                    break;
                case cc.KEY.up:
                    delta[1] = 10;
                    break;
                case cc.KEY.down:
                    delta[1] = -10;
                    break;
            }
            for (var i = 0; i < this._area!.vertices.length; ++i) {
                math.vec3.add(this._area!.vertices[i], this._area!.vertices[i], delta);
            }
        }

        if (keyCode === cc.KEY.u) {
            this._entity!.shiftComponent(this._area!);
            if (this._originalCursorPosition) {
                nextState = new FrontViewCoating(this._area!, Number(false), this._originalCursorPosition);
                (nextState as FrontViewCoating).cancelAllActions();
            }
            PlanManager.getInstance().frontViewLayer.renderCurrentWall();
        }
        if (keyCode === cc.KEY.d) {
            this._entity!.unshiftComponent(this._area!);
            if (this._originalCursorPosition) {
                nextState = new FrontViewCoating(this._area!, Number(false), this._originalCursorPosition);
                (nextState as FrontViewCoating).cancelAllActions();
            }
            PlanManager.getInstance().frontViewLayer.renderCurrentWall();
        }

        if (keyCode === cc.KEY.e) {
            this._transformMode = 1;
        }

        if (keyCode === cc.KEY.shift) {
            this._shiftPressed = true;
        }

        if (this._shiftPressed === false) {
            PlanManager.getInstance().frontViewLayer.renderCurrentWall();
        }

        return nextState;
    }

    keyUnPressed(keyCode: number, ctrl?: boolean, maj?: boolean): ActionState | null {
        if (keyCode === cc.KEY.e) {
            this._transformMode = 0;
        }

        if (keyCode === cc.KEY.shift) {
            this._shiftPressed = false;
        }

        if (keyCode === cc.KEY.left || keyCode === cc.KEY.right || keyCode === cc.KEY.up || keyCode === cc.KEY.down ||
            keyCode === 223 || keyCode === 107 || keyCode === 187 || keyCode === 109) {
            this._updateWebGlDynamicHull();
        }

        return super.keyUnPressed(keyCode);;
    }

    dispose() {
        if (this._addCoatingListener) {
            eventsManager.instance.removeListener(this._addCoatingListener);
        }
    }

    _updateWebGlDynamicHull() {
        // Inform WebGL to update the dynamic hull
        eventsManager.instance.dispatch(Events.COMMAND_EXECUTED, {
            name: Commands.CommandEnum.EditComponentCommand,
            undo: false,
            datas: {
                component: this._area
            }
        });
    }

    _makeRect(left: number, right: number, bottom: number, top: number): ActionState {
        var tmpVertices = this._area!.vertices;

        this._area!.vertices = [];
        var point = math.vec3.create();
        point[0] = left;
        point[2] = bottom;
        point[1] = 0;
        this.mouseClickDown(point);
        point[0] = right;
        this.mouseClickDown(point);
        point[2] = top;
        this.mouseClickDown(point);
        point[0] = left;
        this.mouseClickDown(point);
        // Only if the vertices were really created
        if (this._area!.vertices.length > 0) {
            this._area!.vertices.push(math.vec3.clone(this._area!.vertices[0]));
            point[2] = this._area!.vertices[0][1];
            return this.mouseClickDown(point) as any;
        }
        else {
            // Otherwise ignore and put back old vertices
            this._area!.vertices = tmpVertices;
            return null as any;
        }
    }

    _getSVGAspectRatio(): number {
        if (this._selectedSVG) {
            var SVGElement = this._selectedSVG as any;
            var SVGWidth = SVGElement.viewBox.baseVal.width;
            if (SVGWidth === 0) {
                SVGWidth = SVGElement.width.baseVal.value;
            }
            var SVGHeight = SVGElement.viewBox.baseVal.height;
            if (SVGHeight === 0) {
                SVGHeight = SVGElement.height.baseVal.value;
            }
            if (SVGWidth === 0 || SVGHeight === 0) return 1;
            return SVGHeight / SVGWidth;
        }
        return 1;
    }

    _generateCoatingAreaFromSVG() {
        var center = math.vec3.create();
        for (var i = 0; i < this._area!.vertices.length; ++i) {
            math.vec3.add(center, center, this._area!.vertices[i]);
        }
        math.vec3.divide(center, center, [this._area!.vertices.length, this._area!.vertices.length, this._area!.vertices.length]);
        var width = math.vec3.distance(this._area!.vertices[0], this._area!.vertices[1]);
        var height = math.vec3.distance(this._area!.vertices[0], this._area!.vertices[3]);

        if (this._selectedSVG) {
            var areas = [];
            var SVGElement = this._selectedSVG as any;
            var dx = SVGElement.viewBox.baseVal.x;
            var dy = SVGElement.viewBox.baseVal.y;
            var SVGWidth = SVGElement.viewBox.baseVal.width;
            if (SVGWidth === 0) {
                SVGWidth = SVGElement.width.baseVal.value;
            }
            var SVGHeight = SVGElement.viewBox.baseVal.height;
            if (SVGHeight === 0) {
                SVGHeight = SVGElement.height.baseVal.value;
            }
            if (SVGWidth === 0 || SVGHeight === 0) return;
            var scaleX = width / SVGWidth;
            var scaleY = height / SVGHeight;
            var SVGPaths = SVGElement.querySelectorAll("path");
            for (var j = 0; j < SVGPaths.length; ++j) {
                var path = SVGPaths[j];
                var pathData = path.getPathData();
                if (pathData.length == 0) return;

                // split path by with M type
                var tempPathData = [];
                for (var k = 0; k < pathData.length; ++k) {
                    if (pathData[k].type.toUpperCase() === 'M' && tempPathData.length > 0) {
                        // this must be a hole - do not handle this
                        break;
                    }
                    tempPathData.push(pathData[k]);
                }
                var newVertices = [];
                pathData = tempPathData;
                var moveTo = pathData.shift();
                while (pathData.length > 0) {
                    var data = pathData.shift();
                    var newPathData = [moveTo, data];
                    while (pathData.length > 0 && (data.type.toUpperCase() === 'C' ||
                            data.type.toUpperCase() === 'S' || data.type.toUpperCase() === 'Q' ||
                            data.type.toUpperCase() === 'T') &&
                            (pathData[0].type.toUpperCase() === 'C' || pathData[0].type.toUpperCase() === 'S' ||
                                pathData[0].type.toUpperCase() === 'Q' || pathData[0].type.toUpperCase() === 'T' ||
                                pathData[0].type.toUpperCase() === 'Z')) {
                        data = pathData.shift();
                        newPathData.push(data);
                    }
                    var segment = path.cloneNode(true);
                    segment.setPathData(newPathData);
                    var length = segment.getTotalLength() * Math.max(scaleX, scaleY);
                    var samples = Math.max(1, Math.floor(length / 25));
                    var step = segment.getTotalLength() / samples;
                    for (var k = 0; k < samples; ++k) {
                        var point = segment.getPointAtLength(step * k);
                        newVertices.push(
                            math.vec3.fromValues(
                                center[0] + (point.x - dx - SVGWidth / 2) * scaleX,
                                center[1] + (-point.y + dy + SVGHeight / 2) * scaleY,
                                center[2])
                            );
                    }
                    var endPoint = segment.getPointAtLength(segment.getTotalLength());
                    moveTo = {type: 'M', values: [endPoint.x, endPoint.y]};
                    newVertices.push(
                        math.vec3.fromValues(
                            center[0] + (endPoint.x - dx - SVGWidth / 2) * scaleX,
                            center[1] + (-endPoint.y + dy + SVGHeight / 2) * scaleY,
                            center[2])
                        );
                }
                var newArea = this._area!.clone();
                newArea.vertices = newVertices;
                this._cleanupArea(newArea as Area);
                if (newArea.vertices.length >= 3) {
                    areas.push(newArea);
                }
            }
            PlanManager.getInstance().executeCommand(new Commands.AddComponentsCommand(areas, this._entity!, false));
        }
    }

    _cleanupArea(area: Area) {
        if (area.vertices.length > 2) {
            for (var i = 0; i < area.vertices.length; ++i) {
                var current = area.vertices[i];
                var next = area.vertices[(i + 1) % area.vertices.length];
                var second = area.vertices[(i + 2) % area.vertices.length];
                var segment = new Segment(current, second);
                    if (segment.isPointOnSegment(next, 0.01) === true) {
                        area.vertices.splice((i + 1) % area.vertices.length, 1);
                        i -= 1;
                }
            }
        }
    }

    // Is the area shape valid
    _isValid(): boolean {
        var i, j,
            vertices1 = this._area!.vertices,
            segment1,
            segment2;

        // Current area has less than 3 points but still drawing (--> Ok)
        if (this._area!.vertices.length < 3 && this._isDrawingPoint) {
            FrontViewManager.setAreaValidity(this._area! as Area, true);
            return true;
        } else if (this._area!.vertices.length > 2) {
            for ( i = 0; i < this._area!.vertices.length; ++i) {
                var current = this._area!.vertices[i];
                var next = this._area!.vertices[(i + 1) % this._area!.vertices.length];
                var second = this._area!.vertices[(i + 2) % this._area!.vertices.length];
                var segment = new Segment(current, second);
                    if (segment.isPointOnSegment(next, 0.01) === true) {
                    FrontViewManager.setAreaValidity(this._area! as Area, false);
                    return false;
                }
            }
        }

        // Segment of the area can not cross each other
        for (i = 0; i < vertices1.length - (this._isDrawingPoint ? 1 : 0); i++) {
            // Create a segment with polygon current point and next point
            segment1 = new Segment(vertices1[i], vertices1[(i + 1) % vertices1.length]);

            // Segment too small, invalid area
            if (segment1.length < SavaneConstants.PositionTolerance) {
                FrontViewManager.setAreaValidity(this._area as Area, false);
                return false;
            }

            // Parse all other vertices and check segments aren't crossing
            for (j = 0; j < vertices1.length; j++) {
                //do not test same segment and adjacent one
                if (Math.abs(i - j) > 1 && !(i === 0 && j === vertices1.length - 1) && !(j === 0 && i === vertices1.length - 1)) {
                    // Create a second segment with the next 2 points
                    segment2 = new Segment(vertices1[j], vertices1[(j + 1) % vertices1.length]);
                    if (Segment.areSegmentCrossing(segment1, segment2, SavaneConstants.PositionTolerance) && !(this._isDrawingPoint && (i === vertices1.length - 1 || j === vertices1.length - 1))) {
                        FrontViewManager.setAreaValidity(this._area as Area, false);
                        return false;
                    }
                }
            }
        }

        // If reach here, then the shape is valid
        FrontViewManager.setAreaValidity(this._area! as Area, true);
        return true;
    }

}
